<template>
  <v-container>
    <v-layout wrap>
      <v-flex
        offset-xs1
      >
        <card-carregando v-if="isLoading" />
        <v-card
          v-if="!isLoading"
          max-width="900"
        >
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-btn 
                round 
                color="success" 
                class="text-none"
                @click="gerarRelatorioExcelDetalhesOrganizacao"
              >
                Gerar Relatório Excel
              </v-btn>
            <v-tabs
              v-model="tabs"
            >
              <v-tab
                href="#tab-1"
              >
                Detalhes da Inscrição
              </v-tab>
              <v-tab
                href="#tab-2"
                v-if="habilitacaoOrganizacaoGetter.st_validado"
              >
                Detalhes da Habilitação
              </v-tab>
            </v-tabs>
            <v-tabs-items
              v-model="tabs"
            >
              <v-tab-item
                value="tab-1"
              >
                <organizacao-detalhes-inscricao-visualizacao />
              </v-tab-item>
              <v-tab-item
                value="tab-2"
                v-if="habilitacaoOrganizacaoGetter.st_validado"
              >
                <habilitacao-organizacao-detalhes-visualizacao />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import OrganizacaoDetalhesInscricaoVisualizacao from './OrganizacaoDetalhesInscricaoVisualizacao';
import HabilitacaoOrganizacaoDetalhesVisualizacao from './HabilitacaoOrganizacaoDetalhesVisualizacao';
import CardCarregando from '@/modules/shared/components/CardCarregando';

export default {
  name: 'OrganizacaoDetalhesInscricao',
  components: {
    OrganizacaoDetalhesInscricaoVisualizacao,
    HabilitacaoOrganizacaoDetalhesVisualizacao,
    CardCarregando,
  },
  data: () => ({
    usuarioLogado: {},
    dadosHabilitacao: {},
    isLoading: true,
    tabs: 'tab-1'
  }),
  computed: {
    ...mapGetters({
      usuario: 'conta/usuario',
      organizacaoGetter: 'organizacao/organizacao',
      habilitacaoOrganizacaoGetter: 'organizacao/habilitacaoOrganizacao',
    }),
  },
  watch: {
    usuario(valor) {
      this.usuarioLogado = valor;
    },
    usuarioLogado(usuario) {
      if (usuario.co_organizacao) {
        this.obterDadosOrganizacao(usuario.co_organizacao);
        this.obterDadosHabilitacaoOrganizacao(usuario.co_organizacao);
      }
    },
    habilitacaoOrganizacaoGetter() {
      this.isLoading = false;
    },
  },
  methods: {
    ...mapActions({
      obterDadosOrganizacao: 'organizacao/obterDadosOrganizacao',
      obterDadosHabilitacaoOrganizacao: 'organizacao/obterDadosHabilitacaoOrganizacao',
      gerarRelatorioExcelDetalhesOrganizacaoAction: 'organizacao/exportarExcelDetalhesOrganizacao'
    }),
    gerarRelatorioExcelDetalhesOrganizacao(){
      this.gerarRelatorioExcelDetalhesOrganizacaoAction(this.usuario.co_organizacao);
    }
  },
  mounted() {
    this.usuarioLogado = this.usuario;
    if ((this.organizacaoGetter || {}).organizacaoHabilitacao) {
      this.dadosHabilitacao = this.organizacaoGetter.organizacaoHabilitacao;
    }
  },
};
</script>
